import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Visitor } from '../models/visitor.model';
import { VisitorChild } from '../models/visitorChild';

@Injectable({
  providedIn: 'root'
})

export class VisitorService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  saveVisitor(visitor: Visitor, combineDate: Array<VisitorChild>, signatureFile: any,directMessageFile?: any, acceptsDirectMessages?: any) {
    const formData = new FormData();
    Object.keys(visitor).forEach(key => formData.append(key, visitor[key]));
    formData.append("children", JSON.stringify(combineDate));
    if(sessionStorage.selectedRoom) {
      formData.append('roomId', sessionStorage.selectedRoom);
    }
    formData.append('signature', signatureFile, `${visitor.fullName.replace(/\s/g,'_')}${visitor.phone}.pdf`)
    formData.append('acceptsDirectMessages', acceptsDirectMessages)
    return this.http.post(this.apiUrl + 'visitor', formData);
  }


  saveGroupRegistration(visitor: Visitor, visitors: Array<VisitorChild>, signatureFile) {
    const formData = new FormData();
    //Object.keys(visitor).forEach(key => formData.append(key, visitor[key]));
    formData.append("LeaderFullName", visitor.fullName);
    formData.append("children", JSON.stringify(visitors));
    formData.append("email", visitor.email);
    formData.append("phone", visitor.phone);
    formData.append("address", visitor.address);
    formData.append("city", visitor.city);
    if(sessionStorage.selectedRoom) {
      formData.append('roomId', sessionStorage.selectedRoom);
    }
    formData.append('signature', signatureFile, `${visitor.fullName.replace(/\s/g,'_')}${visitor.phone}.pdf`)
    return this.http.post(this.apiUrl + 'groupvisit', formData);
  }
}
